import { Container, Grid, Stack, Box } from '@mui/material';
import { useCallback, useEffect, useMemo } from 'react';
import InterestsIcon from '@mui/icons-material/Interests';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { BsTelephone } from 'react-icons/bs';
import { FaRegUser } from 'react-icons/fa';
import { GiModernCity, GiSwapBag } from 'react-icons/gi';
import { HiOutlineMail } from 'react-icons/hi';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';
import ViewCardComponent from '../../components/ViewCards';
import { isValidValue } from '../../utils/CommonFunction';
import { getBankViewData } from '../../store/Slice/Bank/BankSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useBankSelector from '../../store/Slice/Bank/BankSelector';

const ICON_SIZE = 24;
const ICON_CLASS = 'viewLabelIcon';

const getFields = (model, config) =>
  config.map(({ label, key, icon }) => ({
    label,
    value: model?.[key],
    icon: <icon.type {...icon.props} className={ICON_CLASS} size={ICON_SIZE} />
  }));

function ViewBankops() {
  const dispatch = useDispatch();
  const location = useLocation();
  const rowId = location.state || {};
  const { LoginData } = useLoginSelector();
  const { BankViewData } = useBankSelector();

  const getBankViewAPi = useCallback(() => {
    dispatch(
      getBankViewData({
        companyId: LoginData?.companyId,
        userId: LoginData?.userId,
        leadId: rowId?.leadId,
        stageId: rowId?.stageId
      })
    );
  }, [LoginData, rowId, dispatch]);

  useEffect(() => {
    getBankViewAPi();
  }, [getBankViewAPi]);

  const sections = useMemo(() => {
    const data = BankViewData || {};
    return [
      {
        title: 'Loan Requirement',
        model: data.bankOpsEntityLoanRequirementResponseModel,
        fields: [
          { label: 'Name', key: 'leadName', icon: <FaRegUser /> },
          { label: 'Phone', key: 'leadPhoneNumber', icon: <BsTelephone /> },
          { label: 'Loan Type', key: 'loanType', icon: <InterestsIcon /> },
          { label: 'Employment Type', key: 'employmentType', icon: <InterestsIcon /> },
          { label: 'Loan Amount', key: 'loanAmount', icon: <GiSwapBag /> },
          { label: 'City', key: 'city', icon: <GiModernCity /> },
          { label: 'Email', key: 'leadEmail', icon: <HiOutlineMail /> }
        ]
      },
      {
        title: 'Submission Details',
        model: data.bankOpsEntitySubmissionDetailsResponseModel,
        fields: [
          { label: 'Bank Name', key: 'bankName', icon: <FaRegUser /> },
          { label: 'Mode of Submission', key: 'modeOfSubmission', icon: <InterestsIcon /> },
          { label: 'Processing Center', key: 'processingCentre', icon: <InterestsIcon /> },
          { label: 'Person Name', key: 'personName', icon: <GiSwapBag /> },
          { label: 'Submitted On', key: 'submittedOn', icon: <GiModernCity /> },
          { label: 'Comments', key: 'comments', icon: <HiOutlineMail /> }
        ]
      },
      {
        title: 'Submission Details', // Intentional duplication per user instructions
        model: data.bankOpsEntityLoginProfileResponseModel,
        fields: [
          { label: 'Company Name', key: 'companyName', icon: <FaRegUser /> },
          { label: 'DSA Name', key: 'dsaName', icon: <InterestsIcon /> },
          { label: 'Lan Id', key: 'lanId', icon: <InterestsIcon /> },
          { label: 'Source Type', key: 'sourceType', icon: <GiSwapBag /> },
          { label: 'Current Stage', key: 'currentStage', icon: <GiModernCity /> },
          { label: 'Current Status', key: 'currentStatus', icon: <HiOutlineMail /> },
          { label: 'Source Flag', key: 'sourceFlag', icon: <HiOutlineMail /> },
          { label: 'login Profile Id', key: 'loginProfileId', icon: <HiOutlineMail /> }
        ]
      },
      {
        title: 'Submission Details', // Intentional duplication per user instructions
        model: data.bankOpsEntityBankProcessingResponseModel,
        fields: [
          { label: 'branchName', key: 'branchName', icon: <FaRegUser /> },
          { label: 'relationshipManager', key: 'relationshipManager', icon: <InterestsIcon /> },
          { label: 'rmContactNumber', key: 'rmContactNumber', icon: <InterestsIcon /> },
          { label: 'employeeContactNumber', key: 'employeeContactNumber', icon: <GiSwapBag /> }
        ]
      }
    ];
  }, [BankViewData]);

  return (
    <Page title="Partner Management System || Bankops">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Application Progress Report" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Scrollbar>
            <Grid container spacing={3} mb={3}>
              {sections.map(
                (section, index) =>
                  isValidValue(section.model) && (
                    <ViewCardComponent
                      key={index}
                      title={section.title}
                      fields={getFields(section.model, section.fields)}
                    />
                  )
              )}
            </Grid>
          </Scrollbar>
        </Box>
      </Container>
    </Page>
  );
}

export default ViewBankops;
